/**
 * Multi-tier reward bar UI + threshold gift reconcile (pipeline via sc-cart-queue).
 * AUD thresholds convert to presentment via Shopify.currency.rate (Markets).
 * 3% discount tier is display-only — native automatic discount at go-live.
 */
(function () {
  if (window.__SC_REWARD_BAR_INIT__) return;
  window.__SC_REWARD_BAR_INIT__ = true;

  var THRESHOLD_GIFT_PROP = '_sc_threshold_gift';
  var THRESHOLD_GIFT_QTY = 1;
  var _lastGoodCart = null;
  var _updateCoalesceTimer = null;
  var _teaserSettleTimer = null;
  var CART_EVENT_COALESCE_MS = 50;
  var TEASER_SETTLE_MS = 220;
  var TIER_POSITIONS = {
    2: [35, 75],
    3: [15, 50, 85]
  };
  var DEFAULT_AWAY_MESSAGE = 'You are {amount} away from {reward}';
  var DEFAULT_UNLOCKED_MESSAGE = "You've unlocked {reward}";

  function isValidCart(cart) {
    return !!(cart && typeof cart.item_count === 'number' && Array.isArray(cart.items));
  }

  function getPresentmentCurrency() {
    var bar = document.querySelector('[data-sc-reward-bar]');
    if (bar && bar.getAttribute('data-presentment-currency')) {
      return bar.getAttribute('data-presentment-currency');
    }
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'AUD';
  }

  function getConversionRate() {
    if (getPresentmentCurrency() === 'AUD') return 1;
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
    return rate > 0 ? rate : 1;
  }

  function convertAudCents(audCents, roundUp) {
    var cents = parseInt(audCents, 10) || 0;
    if (cents <= 0) return 0;
    var rate = getConversionRate();
    if (rate === 1) return cents;
    var converted = cents * rate;
    if (roundUp) {
      converted = Math.ceil(converted / 100) * 100;
    } else {
      converted = Math.round(converted);
    }
    return converted;
  }

  /* Includes Package Protection: Shopify counts that line toward automatic
     discount minimums, so the bar must measure the same basis as checkout. */
  function merchandiseSubtotalCents(cart) {
    if (!isValidCart(cart) || !cart.items.length) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[THRESHOLD_GIFT_PROP] === 'true') continue;
      total += item.final_line_price || 0;
    }
    return total;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function formatMoneyWholeUnitsRoundUp(cents) {
    var value = parseInt(cents, 10) || 0;
    if (value <= 0) return formatMoney(0);
    var rounded = Math.ceil(value / 100) * 100;
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      var wholeFormat = theme.settings.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{amount_no_decimals_with_comma_separator}}')
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, '{{amount_no_decimals_with_comma_separator}}')
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, '{{amount_no_decimals}}')
        .replace(/\{\{\s*amount\s*\}\}/g, '{{amount_no_decimals}}');
      return theme.Currency.formatMoney(rounded, wholeFormat);
    }
    return String(Math.ceil(value / 100));
  }

  function getTierLabel(marker) {
    return (marker.getAttribute('data-tier-label') || 'your next reward').trim();
  }

  function getTierAwayMessage(marker) {
    var message = (marker.getAttribute('data-tier-away-message') || '').trim();
    return message || DEFAULT_AWAY_MESSAGE;
  }

  function getTierUnlockedMessage(marker) {
    var message = (marker.getAttribute('data-tier-unlocked-message') || '').trim();
    return message || DEFAULT_UNLOCKED_MESSAGE;
  }

  function applyMessageTemplate(template, amountCents, rewardLabel) {
    var amount = formatMoneyWholeUnitsRoundUp(amountCents);
    var reward = String(rewardLabel || '').trim();
    return String(template || '')
      .replace(/\{amount\}/g, amount)
      .replace(/\{reward\}/g, reward);
  }

  function getMarkers(bar) {
    return Array.prototype.slice.call(bar.querySelectorAll('.sc-reward-bar__marker'));
  }

  function markerLeftPct(marker) {
    var inlineLeft = marker.style && marker.style.left;
    if (inlineLeft && inlineLeft.indexOf('%') !== -1) {
      return parseFloat(inlineLeft);
    }
    var tierIndex = parseInt(marker.getAttribute('data-tier-index'), 10);
    var markers = getMarkers(marker.closest('[data-sc-reward-bar]'));
    var positions = TIER_POSITIONS[markers.length] || TIER_POSITIONS[3];
    return positions[tierIndex - 1] || 50;
  }

  function applyThresholdConversion(bar) {
    if (!bar) return;

    var markers = getMarkers(bar);
    if (!markers.length) return;

    markers.sort(function (a, b) {
      return parseInt(a.getAttribute('data-aud-threshold-cents'), 10) - parseInt(b.getAttribute('data-aud-threshold-cents'), 10);
    });

    var maxConverted = 0;
    var positions = TIER_POSITIONS[markers.length] || TIER_POSITIONS[3];

    markers.forEach(function (marker, idx) {
      var aud = parseInt(marker.getAttribute('data-aud-threshold-cents'), 10);
      var roundUp = marker.getAttribute('data-round-up') === 'true';
      var converted = convertAudCents(aud, roundUp);
      marker.setAttribute('data-threshold-cents', String(converted));
      marker.setAttribute('data-tier-index', String(idx + 1));
      if (positions[idx] != null) {
        marker.style.left = positions[idx] + '%';
      }
      if (converted > maxConverted) maxConverted = converted;

      var thresholdEl = marker.querySelector('.sc-reward-bar__threshold');
      if (thresholdEl) thresholdEl.textContent = formatMoney(converted);
    });

    bar.setAttribute('data-max-threshold', String(maxConverted));
    bar.classList.toggle('sc-reward-bar--tiers-2', markers.length === 2);
    bar.classList.toggle('sc-reward-bar--tiers-3', markers.length === 3);

    var audGift = parseInt(bar.getAttribute('data-aud-gift-threshold-cents'), 10);
    if (audGift > 0) {
      bar.setAttribute('data-gift-threshold-cents', String(convertAudCents(audGift, true)));
    }
  }

  function hasThresholdGiftInCart(cart) {
    if (!isValidCart(cart)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties || {};
      if (props[THRESHOLD_GIFT_PROP] === 'true') return true;
    }
    return false;
  }

  function getConvertedGiftThresholdCents(teaser) {
    var bar = document.querySelector('[data-sc-reward-bar]');
    if (bar) {
      applyThresholdConversion(bar);
      var fromBar = parseInt(bar.getAttribute('data-gift-threshold-cents'), 10);
      if (fromBar > 0) return fromBar;
    }
    var audGift = parseInt(teaser.getAttribute('data-aud-gift-threshold-cents'), 10);
    return audGift > 0 ? convertAudCents(audGift, true) : 0;
  }

  function fetchFreshCartForTeaser() {
    if (window.SC_getSharedCart) {
      return window.SC_getSharedCart({ forceFresh: true });
    }
    if (window.theme && theme.cart && theme.cart.getCart) {
      return theme.cart.getCart();
    }
    return Promise.resolve(null);
  }

  function scheduleSettledTeaserVisibility() {
    clearTimeout(_teaserSettleTimer);
    _teaserSettleTimer = setTimeout(function () {
      _teaserSettleTimer = null;
      fetchFreshCartForTeaser().then(function (cart) {
        if (isValidCart(cart)) updateGiftTeaserVisibility(cart);
      }).catch(function () {});
    }, TEASER_SETTLE_MS);
  }

  function updateGiftTeaserVisibility(cart) {
    var teaser = document.querySelector('[data-sc-threshold-gift-teaser]');
    if (!teaser) return;

    var thresholdGiftInCart = hasThresholdGiftInCart(cart);
    if (thresholdGiftInCart) {
      teaser.setAttribute('hidden', '');
      return;
    }

    var giftThreshold = getConvertedGiftThresholdCents(teaser);
    if (!giftThreshold) {
      teaser.setAttribute('hidden', '');
      return;
    }

    var subtotal = cart && isValidCart(cart) ? merchandiseSubtotalCents(cart) : 0;
    var shouldHide = subtotal >= giftThreshold;

    if (shouldHide) {
      teaser.setAttribute('hidden', '');
      return;
    }

    teaser.removeAttribute('hidden');

    var messageEl = teaser.querySelector('[data-sc-teaser-message]');
    if (messageEl) {
      var template = teaser.getAttribute('data-teaser-template') || 'Today only offer, orders over {amount}';
      messageEl.textContent = template.replace('{amount}', formatMoney(giftThreshold));
    }
  }

  function segmentedFillPct(subtotalCents, thresholds, positions) {
    if (!thresholds.length) return 0;

    var anchorsCents = [0].concat(thresholds);
    var anchorsPos = [0].concat(positions);

    if (subtotalCents >= thresholds[thresholds.length - 1]) {
      return 100;
    }

    var pct = 0;
    for (var i = 0; i < anchorsCents.length - 1; i++) {
      if (subtotalCents >= anchorsCents[i] && subtotalCents < anchorsCents[i + 1]) {
        var span = anchorsCents[i + 1] - anchorsCents[i];
        if (span <= 0) break;
        var f = (subtotalCents - anchorsCents[i]) / span;
        pct = anchorsPos[i] + f * (anchorsPos[i + 1] - anchorsPos[i]);
        break;
      }
    }
    return pct;
  }

  function updateRewardBarUI(cart) {
    if (!isValidCart(cart)) return;
    _lastGoodCart = cart;
    var bars = document.querySelectorAll('[data-sc-reward-bar]');
    for (var b = 0; b < bars.length; b++) updateSingleRewardBar(bars[b], cart);
  }

  window.SC_refreshRewardBars = function () {
    if (isValidCart(_lastGoodCart)) updateRewardBarUI(_lastGoodCart);
  };

  function updateSingleRewardBar(bar, cart) {
    if (!bar) return;

    applyThresholdConversion(bar);

    var maxThreshold = parseInt(bar.getAttribute('data-max-threshold'), 10);
    if (!maxThreshold || maxThreshold <= 0) return;

    var offset = parseInt(bar.getAttribute('data-sc-reward-offset-cents'), 10);
    if (!isFinite(offset) || offset < 0) offset = 0;

    var total = merchandiseSubtotalCents(cart) + offset;

    var fill = bar.querySelector('[data-sc-reward-fill]');
    var track = bar.querySelector('.sc-reward-bar__track');
    var headlineText = bar.querySelector('[data-sc-reward-headline-text]');

    var markers = getMarkers(bar);
    var nextTier = null;

    markers.sort(function (a, b) {
      return parseInt(a.getAttribute('data-threshold-cents'), 10) - parseInt(b.getAttribute('data-threshold-cents'), 10);
    });

    var thresholds = markers.map(function (marker) {
      return parseInt(marker.getAttribute('data-threshold-cents'), 10);
    });

    var positions = markers.map(markerLeftPct);

    var fillPct = segmentedFillPct(total, thresholds, positions);

    if (fill) {
      fill.style.width = fillPct + '%';
    }
    if (track) {
      var ariaNow = thresholds.length && total >= thresholds[thresholds.length - 1]
        ? 100
        : Math.round(fillPct);
      track.setAttribute('aria-valuenow', String(ariaNow));
    }

    markers.forEach(function (marker) {
      var threshold = parseInt(marker.getAttribute('data-threshold-cents'), 10);
      var unlocked = total >= threshold;
      marker.classList.toggle('is-unlocked', unlocked);
      if (!unlocked && !nextTier) nextTier = marker;
    });

    if (!headlineText) return;

    if (!nextTier) {
      var lastMarker = markers[markers.length - 1];
      if (lastMarker) {
        headlineText.textContent = applyMessageTemplate(
          getTierUnlockedMessage(lastMarker),
          0,
          getTierLabel(lastMarker)
        );
      } else {
        headlineText.textContent = applyMessageTemplate(DEFAULT_UNLOCKED_MESSAGE, 0, 'all rewards');
      }
      return;
    }

    var nextThreshold = parseInt(nextTier.getAttribute('data-threshold-cents'), 10);
    var remaining = nextThreshold - total;
    if (remaining < 0) remaining = 0;

    headlineText.textContent = applyMessageTemplate(
      getTierAwayMessage(nextTier),
      remaining,
      getTierLabel(nextTier)
    );
  }

  function isManagedThresholdGiftLine(item, variantId) {
    return !!(item && item.variant_id === variantId && item.properties && item.properties[THRESHOLD_GIFT_PROP] === 'true');
  }

  function findThresholdGiftLines(items, variantId) {
    if (!items || !variantId) return [];
    var lines = [];
    for (var i = 0; i < items.length; i++) {
      if (isManagedThresholdGiftLine(items[i], variantId)) lines.push(items[i]);
    }
    return lines;
  }

  function thresholdGiftTotalQty(lines) {
    var total = 0;
    for (var i = 0; i < lines.length; i++) total += lines[i].quantity || 0;
    return total;
  }

  window.SC_merchandiseSubtotalCents = merchandiseSubtotalCents;
  window.SC_convertAudCents = convertAudCents;

  window.SC_thresholdGiftStatePart = function (cart) {
    if (!isValidCart(cart)) return 't:0';
    var bar = document.querySelector('[data-sc-reward-bar]');
    if (!bar) return 't:0';
    var variantId = parseInt(bar.getAttribute('data-gift-variant-id'), 10);
    if (!variantId) return 't:0';
    var lines = findThresholdGiftLines(cart.items, variantId);
    var qty = thresholdGiftTotalQty(lines);
    return qty > 0 ? ('t:1:' + qty) : 't:0';
  };

  window.SC_desiredThresholdGiftStatePart = function (cart) {
    if (!isValidCart(cart)) return 't:0';
    var bar = document.querySelector('[data-sc-reward-bar]');
    if (!bar) return 't:0';
    applyThresholdConversion(bar);
    var threshold = parseInt(bar.getAttribute('data-gift-threshold-cents'), 10);
    if (!threshold) return 't:0';
    var subtotal = merchandiseSubtotalCents(cart);
    return subtotal >= threshold ? ('t:1:' + THRESHOLD_GIFT_QTY) : 't:0';
  };

  window.SC_thresholdGiftActionForCart = function (cart) {
    if (!isValidCart(cart)) return 'noop';
    var bar = document.querySelector('[data-sc-reward-bar]');
    if (!bar) return 'skipped:noBar';
    applyThresholdConversion(bar);
    var variantId = parseInt(bar.getAttribute('data-gift-variant-id'), 10);
    var threshold = parseInt(bar.getAttribute('data-gift-threshold-cents'), 10);
    if (!variantId || !threshold) return 'skipped:noConfig';
    var lines = findThresholdGiftLines(cart.items, variantId);
    var subtotal = merchandiseSubtotalCents(cart);
    var shouldHave = subtotal >= threshold;
    var totalGiftQty = thresholdGiftTotalQty(lines);
    if (shouldHave && !lines.length) return 'addGift';
    if (!shouldHave && lines.length) return 'removeGift';
    if (shouldHave && lines.length && (lines.length > 1 || totalGiftQty !== THRESHOLD_GIFT_QTY)) return 'fixGiftQty';
    return 'noop';
  };

  function giftMutation(url, body) {
    if (!window.SC_executeGiftMutation) return Promise.resolve(null);
    return window.SC_executeGiftMutation(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
  }

  function applyBarUpdate(cart) {
    if (isValidCart(cart)) {
      _lastGoodCart = cart;
      if (window.SC_setLastCart) window.SC_setLastCart(cart, Date.now());
      updateRewardBarUI(cart);
    }
    scheduleSettledTeaserVisibility();
  }

  window.SC_reconcileThresholdGiftForCart = function (cart) {
    if (!isValidCart(cart)) return Promise.resolve(cart);

    var bar = document.querySelector('[data-sc-reward-bar]');
    if (!bar) return Promise.resolve(cart);

    applyThresholdConversion(bar);
    var variantId = parseInt(bar.getAttribute('data-gift-variant-id'), 10);
    var threshold = parseInt(bar.getAttribute('data-gift-threshold-cents'), 10);
    if (!variantId || !threshold) return Promise.resolve(cart);

    var lines = findThresholdGiftLines(cart.items, variantId);
    var subtotal = merchandiseSubtotalCents(cart);
    var shouldHave = subtotal >= threshold;
    var totalGiftQty = thresholdGiftTotalQty(lines);
    var needsAdd = shouldHave && !lines.length;
    var needsRemove = !shouldHave && lines.length > 0;
    var needsFixQty = shouldHave && lines.length && (lines.length > 1 || totalGiftQty !== THRESHOLD_GIFT_QTY);

    if (!needsAdd && !needsRemove && !needsFixQty) {
      return Promise.resolve(cart);
    }

    var chain = Promise.resolve(cart);

    if (needsAdd) {
      chain = chain.then(function (c) {
        return giftMutation('/cart/add.js', {
          items: [{
            id: variantId,
            quantity: THRESHOLD_GIFT_QTY,
            properties: { _sc_threshold_gift: 'true' }
          }]
        }).then(function (updated) {
          return updated || c;
        });
      });
    } else if (needsFixQty) {
      if (lines.length > 1) {
        lines.slice(1).forEach(function (line) {
          chain = chain.then(function (c) {
            return giftMutation('/cart/change.js', { id: line.key, quantity: 0 }).then(function (updated) {
              return updated || c;
            });
          });
        });
      }
      var keeper = lines[0];
      chain = chain.then(function (c) {
        if (keeper && (keeper.quantity || 0) !== THRESHOLD_GIFT_QTY) {
          return giftMutation('/cart/change.js', { id: keeper.key, quantity: THRESHOLD_GIFT_QTY }).then(function (updated) {
            return updated || c;
          });
        }
        return c;
      });
    } else if (needsRemove) {
      lines.forEach(function (line) {
        chain = chain.then(function (c) {
          return giftMutation('/cart/change.js', { id: line.key, quantity: 0 }).then(function (updated) {
            return updated || c;
          });
        });
      });
    }

    return chain.then(function (updated) {
      return isValidCart(updated) ? updated : cart;
    }).catch(function (err) {
      console.error('[SC Reward Bar] threshold gift pipeline failed', err);
      return cart;
    });
  };

  function resolveCartFromEvent(evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (isValidCart(cart)) return cart;
    return null;
  }

  function runBarUpdate(evt) {
    var cart = resolveCartFromEvent(evt);
    if (isValidCart(cart)) {
      applyBarUpdate(cart);
      return;
    }
    if (window.SC_getSharedCart) {
      window.SC_getSharedCart().then(function (fresh) {
        if (isValidCart(fresh)) applyBarUpdate(fresh);
      }).catch(function () {});
    }
  }

  function onCartUpdated(evt) {
    clearTimeout(_updateCoalesceTimer);
    _updateCoalesceTimer = setTimeout(function () {
      runBarUpdate(evt);
    }, CART_EVENT_COALESCE_MS);
  }

  function initRewardBar() {
    var bars = document.querySelectorAll('[data-sc-reward-bar]');
    for (var i = 0; i < bars.length; i++) applyThresholdConversion(bars[i]);
  }

  function bootstrapBar() {
    initRewardBar();
    if (window.SC_getSharedCart) {
      window.SC_getSharedCart({ forceFresh: true }).then(function (cart) {
        if (isValidCart(cart)) applyBarUpdate(cart);
      }).catch(function () {});
      return;
    }
    if (!window.theme || !theme.cart || !theme.cart.getCart) return;
    theme.cart.getCart().then(function (cart) {
      if (isValidCart(cart)) applyBarUpdate(cart);
    }).catch(function () {});
  }

  document.addEventListener('cart:updated', onCartUpdated);
  document.addEventListener('cart:build', function () {
    initRewardBar();
    setTimeout(function () {
      runBarUpdate({});
    }, 120);
    scheduleSettledTeaserVisibility();
  });
  document.addEventListener('drawerOpen.CartDrawer', function () {
    scheduleSettledTeaserVisibility();
  });
  document.addEventListener('ajaxProduct:added', function (evt) {
    setTimeout(function () {
      runBarUpdate(evt);
    }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapBar);
  } else {
    bootstrapBar();
  }
})();
